(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('CancelarBajaController',CancelarBajaController);

    CancelarBajaController.$inject = ['$uibModalInstance', 'entity', 'SSAsignacion'];

    function CancelarBajaController($uibModalInstance, entity, SSAsignacion) {
        var vm = this;

        vm.sSAsignacion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
		
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSAsignacion.cancelarBaja({idAsignacion: id},
                onSuccess, onError);
        }
		
		function onSuccess(){
			$uibModalInstance.close(true);			
		}
		
		function onError(){
			$uibModalInstance.dismiss();			
		}
    }
})();
